exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".app-main{display:-webkit-box;display:-ms-flexbox;display:flex;min-height:100vh;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;opacity:1;-webkit-transition:opacity .3s ease;transition:opacity .3s ease}.main-content{position:relative;-webkit-box-flex:1;-ms-flex:1;flex:1;z-index:1;margin-top:50px;-webkit-transition:margin .5s;transition:margin .5s}.main-content.is-expanded{margin-left:180px}.main-content.is-collapsed{margin-left:56px}@media screen and (max-width:1023px){.main-content.is-collapsed,.main-content.is-expanded{margin-left:0}}.wrapper.page-content{padding:1.2em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7477a40f","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/core/layouts/Default.vue
// module id = U37N
// module chunks = 66